import React, { useState, useEffect, useRef } from "react";
import { Button, Container, Typography, Grid, Box, Chip, ToggleButton, ToggleButtonGroup, Skeleton } from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView"; // Logo View Icon
import ImageIcon from "@mui/icons-material/Image"; // Booth Photo View Icon
import { getAllExhibitors, scanExhibitor, setAllExhibitors } from "../../redux/actions/ExhibitorActions";

import { useDispatch, useSelector } from 'react-redux'
import SearchBar from "../../components/searchBar";
import { useParams } from "react-router-dom";
import getDeviceInfo from "../../utils/deviceInfo";
import { useNavigate } from "react-router-dom";
import BoothVisitModal from "../../modals/boothVisitModal";
import CheckIcon from '@mui/icons-material/Check';
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import cameraIcon from "../../assets/icons/camera.png";
import { ValidateQRModal } from "../../modals/boothVisitModal";
import ExhibitorGrid from "./ExhibitorGrid";
import { getSettingValueById } from "../../utils/settings";

const HomePage = () => {
  const { link } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state)
  const gridRef = useRef();

  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [exhibitors, setExhibitors] = useState(state.exhibitor.data || []);
  const [viewMode, setViewMode] = useState("logo"); // Default view mode
  const [loading, setLoading] = useState(false); // Loading state
  const [visitModalData, setVisitModalData] = useState(null); // Loading state

  const [loadingValidateQR, setLoadingValidateQR] = useState(false); // Loading state

  useEffect(() => {
    const deviceInfo = getDeviceInfo();

    let device = {
      os: deviceInfo.os,
      browser: deviceInfo.browser,
      deviceType: deviceInfo.deviceType,
    }
    let location = {
      lat: "",
      long: "",
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          location = {
            lat: position.coords.latitude.toString(),
            long: position.coords.longitude.toString(),
          }
        },
        (error) => console.warn("Geolocation error:", error.message)
      );
    } else {
      console.warn("Geolocation is not supported");
    }

    // Check if already registered
    if (!state.user?.token) {
      navigate("/register")
    }

    if (link) {
      setLoadingValidateQR(true); // Set loading state to true
      handleScanExhibitor({ device, location }, link)
    } else {
      // Fetch exhibitors regardless if there is a link
      handleFetchExhibitors()
    }

  }, []);

  const handleScanExhibitor = async (payload, link) => {
    dispatch(scanExhibitor(payload, link, state.user?.token))
      .then((response) => {
        setLoadingValidateQR(false)

        // console.log(response)
        if (!response.status) {
          setVisitModalData("invalid")
        } else {
          // Update the exhibitor data with the updated list
          // console.log(response.data.exhibitors, state.exhibitor.data)
          setVisitModalData(response.data.exhibitor)
          dispatch(setAllExhibitors(response.data))
          setExhibitors(response.data.exhibitors || [])

          setLoading(false); // Data loaded
        }
        // Load exhibitors
        // handleFetchExhibitors();
      })
      .catch((error) => {
        setLoadingValidateQR(false)
        // alert("Something went wrong. Please try again.", error)
        // handleScanExhibitor(payload, link); // Retry on failure
      });
  };

  const handleFetchExhibitors = async () => {
    dispatch(getAllExhibitors(state.user?.token))
      .then((response) => {
        setExhibitors(response.data.exhibitors || []);
        setLoading(false); // Data loaded
      })
      .catch(() => {
        // handleFetchExhibitors(); // Retry on failure
      });
  };

  // Extract unique categories
  const categories = ["All", ...new Set(exhibitors.map((item) => item.category).filter(Boolean))];

  // Filter exhibitors based on category and search query
  const filteredExhibitors = exhibitors.filter((exhibitor) => {
    const matchesCategory =
      selectedCategory === "All" || exhibitor.category === selectedCategory;

    const lowerSearch = searchQuery.toLowerCase();
    const matchesBrand = exhibitor.brandName?.toLowerCase().includes(lowerSearch);
    const matchesBooth = exhibitor.boothNumber?.toString().toLowerCase().includes(lowerSearch);

    return matchesCategory && (matchesBrand || matchesBooth);
  });

  // Group filtered exhibitors by tier (only keep non-empty tiers)
  const exhibitorsByTier = filteredExhibitors.reduce((acc, exhibitor) => {
    if (!acc[exhibitor.tier]) acc[exhibitor.tier] = [];
    acc[exhibitor.tier].push(exhibitor);
    return acc;
  }, {});

  // Get tiers that have at least one exhibitor
  const nonEmptyTiers = Object.entries(exhibitorsByTier).filter(
    ([_, tierExhibitors]) => tierExhibitors.length > 0
  );

  return (
    <Box sx={{ mb: 20 }}>
      <BoothVisitModal
        data={visitModalData}
        handleClose={() => {
          navigate("/")

          console.log(visitModalData)

          gridRef.current.scrollToExhibitor(visitModalData._id);

          setVisitModalData(null)


        }}
        visitedCount={state.exhibitor.totalScanned || 0}
        totalBooths={getSettingValueById("67f653b38e96630fc821ee7b")}
      />
      <ValidateQRModal isOpen={loadingValidateQR} />


      <Container maxWidth="md" sx={{ textAlign: "center", mt: 2 }}>
        <Typography sx={{ textAlign: "left", mt: 2 }} variant="h4" fontWeight="bold" mb={2}>
          My Passport
        </Typography>

        {/* Search Bar */}
        <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

        {/* Scrollable Category Filter */}
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            whiteSpace: "nowrap",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
            gap: 1,
            mb: 2,
            p: 1,
          }}
        >
          {categories.map((category) => (
            <Chip
              key={category}
              label={category}
              clickable
              color={selectedCategory === category ? "primary" : "default"}
              onClick={() => setSelectedCategory(category)}
              sx={{ flexShrink: 0 }}
            />
          ))}
        </Box>
      </Container>

      {/* Visited Booths Counter */}
      {/* {state.exhibitor.totalScanned >= filteredExhibitors.length ?
        <Container maxWidth="md" sx={{ mb: 2, backgroundColor: "#f8b221", textAlign: "center", mt: 2 }}>
          <Box
            onClick={() => navigate("/raffle")}
            sx={{
              cursor: "pointer",
              color: "white",
              padding: "8px",
              borderRadius: "5px",
              fontWeight: "bold",
            }}
          >
            Tap here to see raffle
          </Box>
        </Container>
        :
        <Container maxWidth="md" sx={{ mb: 2, backgroundColor: "#007bff", textAlign: "center", mt: 2 }}>
          <Box
            sx={{
              color: "white",
              padding: "8px",
              borderRadius: "5px",
              fontWeight: "bold",
            }}
          >
            You visited {state.exhibitor.totalScanned || 0} out of {filteredExhibitors.length} booths
          </Box>
        </Container>
      } */}

      <Container maxWidth="md" sx={{ textAlign: "center", mt: 2 }}>
        {/* Show skeletal loaders if loading */}
        {loading ? (
          <>
            {[1, 2].map((_, index) => (
              <Box key={index} sx={{ mt: 4 }}>
                {/* Tier Name Placeholder */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Skeleton variant="text" width={150} height={30} />
                  <Skeleton variant="circular" width={30} height={30} />
                </Box>

                {/* Skeleton Grid */}
                <Grid container spacing={2} justifyContent="center">
                  {[1, 2, 3, 4].map((_, i) => (
                    <Grid item xs={6} sm={4} md={3} key={i}>
                      <Skeleton variant="rectangular" width="100%" height={100} />
                      <Skeleton variant="text" width="60%" sx={{ mt: 1, mx: "auto" }} />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ))}
          </>
        ) : filteredExhibitors.length === 0 ? (
          <Typography variant="h6" sx={{ mt: 4, color: "gray", fontStyle: "italic" }}>
            Nothing matches your search.
          </Typography>
        ) : (
          // Exhibitor Sections Based on Tier (only show non-empty tiers)
          nonEmptyTiers.map(([tier, tierExhibitors]) => {
            return (
              <Box key={tier} sx={{ mt: 4 }}>
                {/* Tier Name and Toggle Switch */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="h6" fontWeight="bold">
                    {tier} Sponsors
                  </Typography>

                  {/* Custom Toggle Switch */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#E0E0E0",
                      borderRadius: "50px",
                      // padding: "4px",
                      // border: "2px solid gray",
                    }}
                  >
                    <ToggleButtonGroup
                      value={viewMode}
                      exclusive
                      onChange={(_, newView) => {
                        if (newView !== null) setViewMode(newView);
                      }}
                      sx={{
                        "& .MuiToggleButton-root": {
                          border: "none",
                          borderRadius: "50px",
                          // padding: "4px 8px", // Adjusted size
                          minWidth: "20px",
                          minHeight: "20px",
                          transition: "0.3s",
                          "& .MuiSvgIcon-root": {
                            fontSize: "12px", // 50% smaller icons
                          },
                          "&.Mui-selected": {
                            backgroundColor: "#616161",
                            color: "white",
                          },
                        },
                      }}
                    >
                      {/* Logo View */}
                      <ToggleButton value="logo">
                        <GridViewIcon />
                      </ToggleButton>

                      {/* Booth Photo View */}
                      <ToggleButton value="boothPhoto">
                        <ImageIcon />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Box>

                {/* Exhibitor Grid */}
                <ExhibitorGrid ref={gridRef} tierExhibitors={tierExhibitors} viewMode={viewMode} />
              </Box>
            )
          })
        )}
      </Container>
    </Box>
  );
};

export default HomePage;
